/**
 * El armazón común de las pantallas del portal: ancho, márgenes y encabezado
 * (título, bajada y acciones), iguales en todas. Antes cada pantalla elegía su
 * propio `p-6`, su tamaño de título y su ancho máximo, y al pasar de una a otra
 * el contenido saltaba de lugar.
 *
 * ⚠️ No pone superficie: cada tarjeta es su `GlassPanel` y cada tabla trae la
 * suya (`superficieUnica.test.ts`).
 */
import type { ReactNode } from 'react'

export function PaginaPortal({ titulo, bajada, acciones, ancho = 'amplio', children }: {
  titulo: string
  bajada?: ReactNode
  acciones?: ReactNode
  /** `angosto` para contenido de lectura (el organigrama, un formulario). */
  ancho?: 'amplio' | 'angosto'
  children: ReactNode
}) {
  return (
    <div className={`${ancho === 'angosto' ? 'max-w-4xl' : 'max-w-7xl'} mx-auto px-4 sm:px-6 py-6 flex flex-col gap-5`}>
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-content">{titulo}</h1>
          {bajada && <p className="text-sm text-content-muted mt-1">{bajada}</p>}
        </div>
        {acciones && <div className="flex flex-wrap items-center gap-2">{acciones}</div>}
      </header>
      {children}
    </div>
  )
}
